import React, { useState, useEffect, useContext } from 'react'
import { ThemeContext } from '../Helper/Context'
import moment from 'moment';
import useFetch from './useFetch'


const Selectslot = ({ slot, hidePopup, closePopup, paymentType }) => {
    const { setShowSignin, mainState, setMainState, resetState } = useContext(ThemeContext);
    const { setShowLoader } = useContext(ThemeContext);
    const [{ response }, dofetch] = useFetch();
    const [apiName, setApiName] = useState('GetEnrollmentOptions')
    const [enrollmentOptions, setEnrollmentOptions] = useState(false);
    const [apiErrors, setApiErrors] = useState(false)
    const [existingPayment, setExistingPayment] = useState(false)
    const [agreeToTerms, setAgreeToTerms] = useState(null)
    // const [enrollmentDetails , setEnrollmentDetails] = useState(false);
    console.log(mainState);
    console.log(slot)
    // console.log(enrollmentOptions.options[0].additionalPaymentPerClass)

    // const childname = (e) =>{
    //     // let childName = ''
    //     mainState.children.filter(e => e.selected === true).map((child, index)=>{
    //         // childName = child.firstName;
    //         // return child;
    //         setSelectedChild(child);
    //     })

    // }

    const handlePaynow = (e, type) => {
        // setMainState({...mainState,section:'enrolment'})
        // setShowLoader(true);
        // closePopup();

        // console.log(JSON.stringify(JSON.stringify(enrollmentData)))
        // setApiName('EnrollMemberToGroup');
        // dofetch(mainState.fetchURL, 'EnrollMemberToGroup', 'EnrollMemberToGroup.post.odata', '', JSON.stringify(enrollmentData));
        // console.log(response);
        if (agreeToTerms) {
            paymentType(e, type);
        } else {
            setAgreeToTerms(false)
        }

    }
    const handleExternalPayment = (e) => {

        if (agreeToTerms) {
            setApiName("externalpayment");
            setShowLoader(true);
            let submittedData = {
                userId: mainState.user.userId,
                thankYouPageUrl: window.location.href,
                assignToContractsMode: "AssignToAllActiveContracts"
            }
            dofetch(mainState.fetchURL, 'InitExternalCreditCardRegistration', 'InitExternalCreditCardRegistration.post.odata', '', JSON.stringify(submittedData));
        } else {
            setAgreeToTerms(false)
        }


    }


    const AttachPayment = (paymentID, contractID) => {
        let objecttoSend = {
            memberPaymentSourceId: parseInt(paymentID),
            contractsIds: [
                contractID
            ]
        }
        console.log(objecttoSend);
        dofetch(mainState.fetchURL, 'AssignPaymentSource', 'AssignPaymentSource.post.odata', '', JSON.stringify(objecttoSend), true);
        setShowLoader(false);
    }
    const handleEnrollmentOptionsFetch = () => {
        let startDate = slot.startDate.split('T')[0];
        let urlparams = `?memberId=${slot.selectedChild.id}&groupId=${slot.groupId}&startDate=${startDate}`;
        dofetch(mainState.fetchURL, 'GetEnrollmentOptions', 'info.get.odata', urlparams, '');
    }

    const enrollChild = (e) => {
        if (agreeToTerms) {
            setApiName("EnrollMemberToGroup");
            setShowLoader(true);
            let enrollmentData = {
                memberId: slot.selectedChild.id,
                groupId: slot.groupId,
                startDate: slot.startDate.split('T')[0],
                endDate: null,
                forceEnrollment: true,
                enrollmentOptionId: 2,
                setRequiredActivityLevel: true,
                notifyMember: true
            }

            // dofetch(mainState.fetchURL, 'EnrollMemberToGroup', 'EnrollMemberToGroup.post.odata', '', JSON.stringify(enrollmentData));
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

            let bodyData = JSON.stringify({
                "integrationcode": "PERFECTGYMAPI",
                "endpointname": 'EnrollMemberToGroup',
                "internalcall": 'EnrollMemberToGroup.post.odata',
                "useheadervariables": true,
                "urlparams": '',
                "body": JSON.stringify(enrollmentData)
            });

            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: bodyData,
                redirect: 'follow'
            };

            // console.log(bodyData);

            fetch(mainState.fetchURL, requestOptions)
                .then(response => {
                    return response.json()

                })
                .then(result => {
                    if (result.contractId === null) {
                        setApiErrors("Failed to create a Contract, Please try again later or if it continues please call Cockburn Arc for assistance.")
                        setShowLoader(false);
                    }
                    else {

                        AttachPayment(existingPayment, result.contractId)
                        //setApiName("EnrollMemberToGroup");
                        console.log(result);
                        console.log('called to enroll')
                        setApiErrors(false)
                        setShowLoader(false);
                        setMainState({
                            ...mainState,
                            section: 'enrolment',
                            isLoggedIn: true,
                            showVerification: false,
                            bookedSlot: slot
                        })
                    }
                })
                .catch(error => {
                    console.log(response.errors);
                    setApiErrors(error)
                    // setShowLoader(false);
                });

        } else {
            setAgreeToTerms(false)
        }


    }
    const IsPaymentSourceExist = () => {
        if (mainState.user.paymentSources.find(x => x.paymentSource === "DirectDebit") || mainState.user.paymentSources.find(x => x.paymentSource === "CreditCard")) {
            return true;
        } else {
            return false
        }
    }
    const getSelectedChild = () => {
        let result = mainState.children.reduce((a, o) => (o.selected && a.push(o.id), a), [])
        console.log(result);
        return result[0]
    }
    const handleExistingPayment = (e) => {
        setExistingPayment(!existingPayment)
    }
    console.log(mainState.user.paymentSources[mainState.user.paymentSources.length - 1])

    useEffect(() => {
        if (apiName === 'EnrollMemberToGroup') {
            if (response) {
                if (response.errors) {
                    console.log(response.errors);
                    setApiErrors(response.errors[0].message)
                    // setShowLoader(false);
                } else {
                    console.log(response);
                    console.log('called to enroll')
                    setApiErrors(false)
                    setShowLoader(false);
                    setMainState({
                        ...mainState,
                        section: 'enrolment',
                        isLoggedIn: true,
                        showVerification: false,
                        bookedSlot: slot
                    })
                }
            }
        }
        if (apiName === 'externalpayment') {
            if (response) {
                if (response.errors || response.message == "Invalid request") {
                    if (response.errors) {
                        console.log(response.errors);
                        setApiErrors(response.errors[0].message)
                    } else {
                        setApiErrors("This payment system is not available at the momment please try again later or try with different payment method");
                        setShowLoader(false);
                    }
                    // setShowLoader(false);
                } else {
                    console.log(response);
                    setApiErrors(false)
                    localStorage.setItem('childDetails', JSON.stringify(slot));

                    window.location.href = response.url;
                    // setMainState({
                    //     ...mainState,
                    //     section: 'enrolment',
                    //     isLoggedIn: true,
                    //     showVerification: false,
                    //     bookedSlot:slot
                    // })
                }
            }
        }
        if (apiName === 'GetEnrollmentOptions') {
            if (response) {
                console.log('called default')
                setEnrollmentOptions(response)
                setShowLoader(false);
            } else {
                handleEnrollmentOptionsFetch();
            }
        }
    }, [response])

    return (
        <div className="perfectgym-popup paynow" onClick={e => { hidePopup(e) }}>
            <div className="popup-content">
                <div className="closebtn" onClick={(e) => closePopup(e)}><i className="fal fa-times"></i></div>
                <h2>Your Selected Class Details for {slot.selectedChild.firstName}</h2>
                {/* {console.log(moment(slot.startDate).format('LT'))} */}
                {apiErrors &&
                    <p className="Error">{apiErrors}</p>
                }

                {enrollmentOptions &&
                    <>
                        {enrollmentOptions.validationResult.memberIsAlreadyInTheGroup &&
                            <p className="Error">{slot.selectedChild.firstName} has already been registered to this group</p>
                        }
                    </>
                }
                <ul>
                    <li>
                        <div className="type">First Class</div>
                        <div className="details"><strong>{moment(slot.startDate).format('dddd')}</strong> {moment(slot.startDate).format('DD MMMM YYYY')}</div>
                    </li>
                    <li>
                        <div className="type">Start Time</div>
                        <div className="details">{moment(slot.startDate).format('h:mm a')}</div>
                    </li>
                    <li>
                        <div className="type">Finish Time</div>
                        <div className="details">{moment(slot.endDate).format('h:mm a')}</div>
                    </li>
                    <li>
                        <div className="type">Zone</div>
                        <div className="details">{slot.clubId}</div>
                    </li>
                    <li>
                        <div className="type">Level</div>
                        <div className="details">{slot.activityMemberLevel.name}</div>
                    </li>
                    <li>
                        <div className="type">Instructor</div>
                        <div className="details">{slot.instructor.firstName + ' ' + slot.instructor.lastName}</div>
                    </li>
                    <li>
                        <div className="type">Price/per week</div>
                        <div className="details">${enrollmentOptions && enrollmentOptions.options[0].additionalPaymentPerClass.toFixed(2)} (billed fortnightly)</div>
                    </li>
                </ul>
                {enrollmentOptions &&
                    <>
                        {!enrollmentOptions.validationResult.memberIsAlreadyInTheGroup &&
                            <div className="checkbox-wrapper">
                                <input id="agreetoterms" type="checkbox" name="agreetoterms" checked={agreeToTerms} onChange={(e) => setAgreeToTerms(!agreeToTerms)} />
                                <label htmlFor="agreetoterms">Agree to <a href="https://www.cockburnarc.com.au/About/Terms-and-Conditions" target="_blank">Terms &amp; Conditions</a> </label>
                            </div>
                        }
                    </>
                }

                {!agreeToTerms && agreeToTerms !== null &&
                    <p className="Error errorline">Please agree to terms &amp; conditions</p>
                }

                {enrollmentOptions &&
                    <>
                        {enrollmentOptions.validationResult.memberIsAlreadyInTheGroup &&
                            <div className="btn-wrapper">
                                <button className="btn btn-border" onClick={(e) => closePopup(e)}>back</button>
                            </div>
                        }
                    </>
                }

                {enrollmentOptions &&
                    <>
                        {!enrollmentOptions.validationResult.memberIsAlreadyInTheGroup &&
                            <>
                                {IsPaymentSourceExist() ?
                                    (
                                        <>
                                            {mainState.user.paymentSources.length > 0 && <div className="checkbox-wrapper"><strong>Select the payment</strong></div>}
                                            {Object.keys(mainState.user.paymentSources).map(key => (
                                                mainState.user.paymentSources[key].paymentSource !== "Cash" && !mainState.user.paymentSources[key].isDeleted &&
                                                <React.Fragment key={key}>
                                                    <div className="checkbox-wrapper">
                                                        <input id={`existingpayment_${mainState.user.paymentSources[key].id}`} type="checkbox" name="existingpayment" checked={existingPayment == mainState.user.paymentSources[key].id} onChange={(e) => setExistingPayment(e.target.value)} value={mainState.user.paymentSources[key].id} />
                                                        <label htmlFor={`existingpayment_${mainState.user.paymentSources[key].id}`}>Use your existing payment using
                                                            {
                                                                <>
                                                                    {mainState.user.paymentSources[key].paymentSource === 'CreditCard' && ' Credit Card'}
                                                                    {mainState.user.paymentSources[key].paymentSource === 'DirectDebit' && ' Direct Debit'}

                                                                    {
                                                                        mainState.user.paymentSources[key].paymentSource === "CreditCard" && ' - **** ' + mainState.user.paymentSources[mainState.user.paymentSources.length - 1].publicData.split('*').pop()
                                                                    }
                                                                </>
                                                            }

                                                        </label>
                                                    </div>
                                                </React.Fragment>
                                            ))}
                                            <div className="checkbox-wrapper">
                                                <input id="existingpayment" type="checkbox" name="existingpayment" checked={!existingPayment} onChange={(e) => setExistingPayment(!existingPayment)} />
                                                <label htmlFor="existingpayment">Add New Payment</label>
                                            </div>
                                            <div className="btn-wrapper">
                                                <button className="btn btn-border" onClick={(e) => closePopup(e)}>back</button>
                                                {existingPayment ?
                                                    (
                                                        <button className="btn" onClick={e => enrollChild(e)}>Book Now</button>
                                                    ) :
                                                    (
                                                        <>
                                                            <div className="paymentWrapper">
                                                                <button className="btn" onClick={e => handlePaynow(e, 'directDebit')}>Pay by direct debit</button>
                                                                <button className="btn" onClick={e => handleExternalPayment(e)}>Pay by credit card</button>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="btn-wrapper">
                                                <button className="btn btn-border" onClick={(e) => closePopup(e)}>back</button>
                                                <div className="paymentWrapper">
                                                    <button className="btn" onClick={e => handlePaynow(e, 'directDebit')}>Pay by direct debit</button>
                                                    <button className="btn" onClick={e => handleExternalPayment(e)}>Pay by credit card</button>
                                                </div>
                                            </div>

                                        </>
                                    )
                                }

                            </>
                        }
                    </>
                }

            </div>
        </div>
    )
}
export default Selectslot
